import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { IStyledVariantProps } from '../../../../model';
import { VariantCommon } from '../../variantsStyled';

type VariantProps = IStyledVariantProps & {
  isDualPrice: boolean;
};

const getNewBorderStyleDesign = (isSelected: boolean, isOnStock: boolean) => {
  const borderWidth = isSelected ? '2px' : '1px';
  const borderColor = isSelected
    ? theme.color.border.selected
    : isOnStock
    ? theme.color.border.divider
    : theme.color.common.gray90;

  return `${borderWidth} solid ${borderColor}`;
};

export const Variant = styled(VariantCommon)<VariantProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ isOnStock, isDualPrice }) =>
    isOnStock && isDualPrice ? 'center' : 'space-between'};
  margin: 0 0 0.25rem;
  border: ${({ isSelected, isOnStock }) =>
    getNewBorderStyleDesign(isSelected, isOnStock)};
  height: 3.5rem;
  width: 6.5rem;
  padding: 0.625rem 0.5rem;
  @media (min-width: ${breakpoints.lg}) {
    width: auto;
    margin: 0;
  }
`;

export const PriceLabelWrapper = styled.div`
  ${theme.typography.labelSmall400}
  color:${theme.color.text.secondary}
`;
